import React from "react";
import { Card } from "../modules/Settings/Tags";

export function TagCardPage(props) {
  return <Card {...props} />;
}
